import getDaysInbetween from 'utils/getDaysInbetween';
import getBasicDate from 'utils/dates/getBasicDate';
function shouldShowEventPill(eventSession) {
  if (!(eventSession !== null && eventSession !== void 0 && eventSession.startDateTime) || (eventSession === null || eventSession === void 0 ? void 0 : eventSession.status) !== 'booked') {
    return false;
  }
  var bookingLocalDate = getBasicDate(new Date(eventSession.startDateTime));
  var today = getBasicDate(new Date());
  var daysUntilBooking = getDaysInbetween(bookingLocalDate, today);
  if (daysUntilBooking < 0) {
    return false;
  }
  return true;
}
export default shouldShowEventPill;